<template>
  <article id="policy-details-covers" data-test-policy-coverages>
    <h2 data-test-policy-coverages-label v-html="modelValue.LabelCoveragesHeadline" />

    <p
      data-test-policy-coverages-additional-headline
      v-html="modelValue.CoveragesAdditionalHeadline"
    />

    <div
      v-for="(coverSection, coverSectionIndex) in modelValue.CoverSections"
      :key="'cover-section-' + coverSectionIndex"
      class="policy-cover-group"
      data-test-policy-coverages-cover-group
    >
      <div
        v-if="coverSection.Title !== ''"
        class="row"
        data-test-policy-coverages-cover-type="cover-group"
      >
        <div class="columns">
          <p>
            <b>{{ coverSection.Title }}</b>
          </p>
        </div>
        <div class="columns" />
      </div>

      <div
        v-for="(cover, coverIndex) in coverSection.Covers"
        :key="coverSectionIndex + '-cover-' + coverIndex"
      >
        <field
          v-model="coverSection.Covers[coverIndex]"
          :name="coverSectionIndex + '-cover-' + coverIndex"
          class="row"
          data-test-policy-coverages-cover-type="cover"
          data-test-policy-coverages-cover
        />
        <info-box
          v-if="editMode && cover.ShowFieldMessage"
          :text="cover.FieldMessage"
          :arrow-show="false"
          :info-box-class="infoBoxClass(cover)"
        />
      </div>
    </div>
  </article>
</template>

<script>
import Field from './Field.vue';
import InfoBox from '@/components/UI/InfoBox.vue';

export default {
  name: 'Coverages',
  components: {
    Field,
    InfoBox
  },
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    editMode() {
      return this.$store.state.policy.editMode;
    }
  },
  methods: {
    infoBoxClass(cover) {
      const infoBoxWarningClass = this.showWarningIcon(cover) ? ' info-box-warning' : '';
      return 'info-box-negative-top-margin' + infoBoxWarningClass;
    },
    showWarningIcon(cover) {
      return cover.ShowFieldMessageWarningIcon;
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

.info-box-negative-top-margin {
  margin-top: rem-calc(-10);
}
</style>
